PREFIX ccf: <http://purl.org/ccf/>
PREFIX HRApop: <https://purl.humanatlas.io/graph/hra-pop>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX owl: <http://www.w3.org/2002/07/owl#>
PREFIX UBERON: <http://purl.obolibrary.org/obo/UBERON_>
PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>
PREFIX body: <http://purl.obolibrary.org/obo/UBERON_0013702>
PREFIX HRA: <https://purl.humanatlas.io/collection/hra-api>

SELECT DISTINCT (?organ_iri AS ?id) (?organ_label AS ?label)
FROM HRA:
FROM HRApop:
WHERE {
  ?as ccf:has_cell_summary [] .
  ?as rdfs:label ?as_label .
  ?as_entity ccf:representation_of ?as ;
             ccf:has_reference_organ ?refOrgan .
  ?refOrgan ccf:representation_of ?refOrganTerm .
  ?organ_iri ccf:ccf_part_of body: .
  ?organ_iri ccf:ccf_pref_label ?organ_label .
  ?refOrganTerm ccf:ccf_part_of* ?organ_iri .
  # Remove redundant 'respiratory system' and 'anatomical systems'
  FILTER (?organ_iri != UBERON:0001004 && ?organ_iri != UBERON:0000467)
}
ORDER BY ?organ_label
